import React from "react";
// @material-ui
import { makeStyles } from "@material-ui/styles";
// react-slick
import Slider from "react-slick";
// slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// styles
import styles from "./MainSlickSliderStyle";
const useStyles = makeStyles(styles);

export default function MainSlickSlider(props) {
  const classes = useStyles();
  const settings = {
    fade: true,
    draggable: true,
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <Slider {...settings}>
      {props.headerInfo.map((item, index) => {
        return (
          <div key={index}>
            {MoveImage}
            <img src={item.img} alt="headerImg" className={classes.sliderImg} />
            <p className={classes.sliderMessage}>{item.message}</p>
          </div>
        );
      })}
    </Slider>
  );
}

const MoveImage = (
  <style>
    {`
      @keyframes moveImage {
        from {
          object-position: 0 50%;
          transform: scale(1,1);
        }
        to {
          object-position: 100% 50%;
          transform: scale(1.3,1.3);
        }
      }
    `}
  </style>
);
